import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SaasDtoKeysEnum } from '@zaoblako/shared/modules/saas/enums/saas-dto-keys.enum';

import * as yup from 'yup';

/** Tenant statistics metric response body - DTO signature */
export interface TenantStatisticsMetricFindInterface {
  /** Created objects count */
  count: number;
  /** Last object creation date */
  latest: Date;
}

/** Tenant statistics metric response body - DTO schema */
export const TenantStatisticsMetricFindDto = SerdeDtoClass.create<TenantStatisticsMetricFindInterface>(SaasDtoKeysEnum.TENANT_STATISTICS_METRIC_FIND_DTO, {
  count: {
    sortable: true,
    label: 'Количество',
    serializer: yup.number(),
  },
  latest: {
    sortable: true,
    label: 'Дата',
    serializer: yup.date(),
  },
});
